import Axios from 'api/client';
import { LegalEntityFile } from 'types/domain';
import { PaginatedData } from 'types/pagination';

const sendVerifySms = (userId: number) => Axios.post(`/users/${userId}/verify-sms/send`);

interface FetchLegalEntityFilesParams {
    limit?: number;
    page?: number;
}

const verifySms = (userId: number, code: string) =>
    Axios.post(`/users/${userId}/verify-sms`, {
        code,
    });

const sendVerifyEmail = (userId: number, accountId: number) =>
    Axios.post(`/users/${userId}/verify-email/send`, {
        account_id: accountId,
    });

interface VerifyNonProfitParams {
    ein: string;
    account_id: string;
    fiscally_sponsored: string;
    fiscally_sponsored_proof?: File;
}

const verifyNonProfit = (userId: number, data: VerifyNonProfitParams) => {
    const formData = new FormData();
    formData.append('ein', data.ein);
    formData.append('account_id', data.account_id);
    formData.append('fiscally_sponsored', data.fiscally_sponsored);
    if (data.fiscally_sponsored_proof) {
        formData.append('fiscally_sponsored_proof', data.fiscally_sponsored_proof);
    }

    return Axios.post(`/users/${userId}/verify-nonprofit`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

interface VerifyNonProfitManuallyParams {
    account_id: string;
    phone_number: string;
    file?: File;
}

const verifyNonProfitManually = (userId: number, data: VerifyNonProfitManuallyParams) => {
    const formData = new FormData();
    formData.append('account_id', data.account_id);
    formData.append('phone_number', data.phone_number);
    if (data.file) {
        formData.append('file', data.file);
    }

    return Axios.post(`/users/${userId}/verify-nonprofit-manual`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const fetchLegalEntityFiles = (accountId: number, params: FetchLegalEntityFilesParams) =>
    Axios.get<PaginatedData<LegalEntityFile>>(`/accounts/${accountId}/legal-entity/files`, {
        params,
    }).then(res => res.data);

const uploadLegalEntityFile = (accountId: number, formData: FormData) =>
    Axios.post(`/accounts/${accountId}/legal-entity/files`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }).then(res => res.data);

export type { FetchLegalEntityFilesParams };

export {
    verifySms,
    sendVerifySms,
    sendVerifyEmail,
    verifyNonProfit,
    verifyNonProfitManually,
    fetchLegalEntityFiles,
    uploadLegalEntityFile,
};
